import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PosSupervisorLoginComponent } from 'src/app/shared/pos-supervisor-login/pos-supervisor-login.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class PosSupervisorLoginService {
  private modalRef?: BsModalRef<PosSupervisorLoginComponent>;
  constructor(private modalService: BsModalService) {
    this.modalService.config.backdrop = 'static';
  }

  show(confirmAction: () => any, privileges: Array<string>, validateAllprivileges?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      validateAllprivileges = validateAllprivileges == undefined ? true : validateAllprivileges;
      this.modalRef = this.modalService.show(PosSupervisorLoginComponent);
      this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY}`);
      this.modalRef.content!.confirmAction = confirmAction;
      this.modalRef.content!.privileges = privileges;
      this.modalRef.content!.validateAllprivileges = validateAllprivileges;
      resolve(confirmAction);
    });
  }

  async showAsync(privileges: Array<string>) {
    this.modalRef = this.modalService.show(PosSupervisorLoginComponent, {
      initialState: {
        isJustForLogin: false,
        disabledUserName: false,
        privileges,
        validateAllprivileges: false
      },
      class: `modal-dialog ${ModalDialogType.PRIMARY}`
    });

    return await this.modalRef.content!.loginInformation.toPromise();
  }

  async showJustForLogin(username: string, disabledUserName: boolean): Promise<boolean> {
    this.modalRef = this.modalService.show(PosSupervisorLoginComponent, {
      initialState: { isJustForLogin: true, username, disabledUserName },
    });
    this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY}`);
    const isValidLogin =
      await this.modalRef.content!.isValidLoginInformation.toPromise();
    return isValidLogin;
  }
}
